import React, { useState, useEffect } from 'react';
import { Colors, Spacing, Typography } from '_styles';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectScreen, selectScreenStatus, setScreen } from '_redux/slices/main-screen/render-screen';

const Topbar = (props) => {

    return (
        <>
            <p>hello</p>
        </>
    );
}

export default Topbar;